<template>
  <div>
    <div class="row mt-20">
      <div class="container">
        <div class="col-md-12">
          <!-- <div id="about-bg" class="bg-pos"></div> -->
          <video loop="true" autoplay="true" controls style="width: 100%">
            <source src="/img/IMG_4537.MOV" type="video/mp4" />
          </video>
        </div>
      </div>
    </div>
    <div class="row mt-20 about_container_wrapper">
      <div class="container">
        <div class="col-md-12">
          <div class="h2 bold text-center">{{ $t('about.we') }} – AppTown</div>
          <div v-html="$t('about.first')"></div>
        </div>
      </div>
    </div>
    <div
      id="seasidetms_row_2tlj7cwwiv"
      class="seasidetms_row seasidetms_color_scheme_default seasidetms_row_top_default seasidetms_row_bot_default seasidetms_row_boxed"
    >
      <div class="seasidetms_row_outer_parent">
        <div class="seasidetms_row_outer">
          <div class="seasidetms_row_inner">
            <div class="seasidetms_row_margin seasidetms_11">
              <div
                id="seasidetms_column_oe58sa2eo9"
                class="seasidetms_column one_first"
              >
                <div class="seasidetms_column_inner">
                  <div
                    id="seasidetms_counters_9jljsxijfp"
                    class="seasidetms_counters counters_type_vertical"
                  >
                    <div class="seasidetms_counter_wrap one_fourth">
                      <div
                        id="seasidetms_counter_w3wu4a6xfq"
                        class="seasidetms_counter counter_has_icon"
                        data-percent="10321"
                      >
                        <div
                          class="seasidetms_counter_inner seasidetms-icon-users"
                        >
                          <span class="seasidetms_counter_counter_wrap">
                            <span class="seasidetms_counter_prefix"></span
                            ><span class="seasidetms_counter_counter"
                              >50824</span
                            ><span class="seasidetms_counter_suffix"></span>
                          </span>
                        </div>
                        <span
                          class="seasidetms_counter_subtitle"
                          v-html="$t('about.counters.1')"
                        ></span>
                        <canvas
                          height="280"
                          width="280"
                          style="height: 140px; width: 140px"
                        ></canvas>
                      </div>
                    </div>
                    <div class="seasidetms_counter_wrap one_fourth">
                      <div
                        id="seasidetms_counter_8zkcwyo3kn"
                        class="seasidetms_counter counter_has_icon"
                        data-percent="4"
                      >
                        <div
                          class="seasidetms_counter_inner seasidetms-icon-direction"
                        >
                          <span class="seasidetms_counter_counter_wrap">
                            <span class="seasidetms_counter_prefix"></span
                            ><span class="seasidetms_counter_counter">5</span
                            ><span class="seasidetms_counter_suffix"></span>
                          </span>
                        </div>
                        <span
                          class="seasidetms_counter_subtitle"
                          v-html="$t('about.counters.3')"
                        ></span>
                        <canvas
                          height="280"
                          width="280"
                          style="height: 140px; width: 140px"
                        ></canvas>
                      </div>
                    </div>
                    <div class="seasidetms_counter_wrap one_fourth">
                      <div
                        id="seasidetms_counter_pmjy066ynl"
                        class="seasidetms_counter counter_has_icon"
                        data-percent="13156"
                      >
                        <div
                          class="seasidetms_counter_inner seasidetms-icon-rocket"
                        >
                          <span class="seasidetms_counter_counter_wrap">
                            <span class="seasidetms_counter_prefix"></span
                            ><span class="seasidetms_counter_counter"
                              >30284</span
                            ><span class="seasidetms_counter_suffix"></span>
                          </span>
                        </div>
                        <span
                          class="seasidetms_counter_subtitle"
                          v-html="$t('about.counters.2')"
                        ></span>
                        <canvas
                          height="280"
                          width="280"
                          style="height: 140px; width: 140px"
                        ></canvas>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row mt-20">
      <div class="container">
        <div class="col-md-12">
          <div class="h2 bold text-center">
            {{ $t('about.weOffer') }}
          </div>
          <p class="paragraph-text">
            {{ $t('about.second') }}
          </p>
        </div>
      </div>
    </div>
    <div class="row mt-20 mb-20">
      <div class="container">
        <div class="col-md-12">
          <div id="about-2-bg" class="bg-pos"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'About',
}
</script>

<style>
.about_container_wrapper {
  padding: 0 15px;
}
</style>
